// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"94caf639","211":"480bb97e","340":"086dafca","345":"47bf3f81","406":"494db1a2","787":"c875205c","867":"3cc432e4"}[chunkId] + ".chunk.js";
};